module.exports = __webpack_public_path__ + "static/media/festival_04.ed2ed082.jpg";